{
  "sparkjs_version_card": {
    "latest_label": "Always use latest"
  }
}
